(function () {
  const MQ = '(max-width: 749px)';

  let variantPopupScrollLockY = 0;

  function isCollectionCardPopup(popup) {
    return Boolean(popup?.classList.contains('collection-card__variant-popup'));
  }

  function getCollectionCardPopup(sectionId) {
    if (!sectionId) return null;
    return document.querySelector(
      `[data-cart-upsell-variant-popup].collection-card__variant-popup[data-section-id="${sectionId}"]`
    );
  }

  function portalCollectionPopup(popup) {
    if (!popup || popup.dataset.collectionPortaled === 'true') return;
    document.body.appendChild(popup);
    popup.dataset.collectionPortaled = 'true';
  }

  function popupPreservesPageScroll(popup) {
    return Boolean(popup?.closest('[data-global-sticky-atc]') || isCollectionCardPopup(popup));
  }

  function popupRedirectsToCart(popup) {
    return Boolean(popup?.closest('[data-global-sticky-atc]') || isCollectionCardPopup(popup));
  }

  function variantPopupScrollLock(popup) {
    if (popupPreservesPageScroll(popup)) {
      document.documentElement.classList.add('variant-popup-open', 'variant-popup-open--preserve-scroll');
      return;
    }

    if (!document.documentElement.classList.contains('variant-popup-open')) {
      variantPopupScrollLockY = window.scrollY || document.documentElement.scrollTop || 0;
      if (window.lenis && typeof window.lenis.scroll === 'number') {
        variantPopupScrollLockY = window.lenis.scroll;
      }
      document.body.style.position = 'fixed';
      document.body.style.top = `-${variantPopupScrollLockY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }
    document.documentElement.classList.add('variant-popup-open');
  }

  function variantPopupTryScrollUnlock(popup) {
    if (document.querySelector('[data-variant-popup-dialog]:not([hidden])')) return;

    if (popupPreservesPageScroll(popup)) {
      document.documentElement.classList.remove('variant-popup-open', 'variant-popup-open--preserve-scroll');
      return;
    }

    document.documentElement.classList.remove('variant-popup-open');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('left');
    document.body.style.removeProperty('right');
    document.body.style.removeProperty('width');
    window.scrollTo(0, variantPopupScrollLockY);
  }

  function getLabelText(fieldset, input) {
    if (!input) return '';
    const labels = fieldset.querySelectorAll('label');
    for (const label of labels) {
      if (label.htmlFor === input.id) {
        const clone = label.cloneNode(true);
        clone.querySelectorAll('.visually-hidden, .label-unavailable').forEach((el) => el.remove());
        return clone.textContent.replace(/\s+/g, ' ').trim();
      }
    }
    return '';
  }

  function updatePeekTexts(popup, fieldset) {
    const inputs = [...fieldset.querySelectorAll('input[type="radio"]')].filter((inp) => !inp.classList.contains('disabled'));
    const fallback = [...fieldset.querySelectorAll('input[type="radio"]')];
    const list = inputs.length ? inputs : fallback;
    const idx = Math.max(0, list.findIndex((inp) => inp.checked));
    const a = getLabelText(fieldset, list[idx]) || '';
    let b = '';
    if (list.length > 1) {
      b = getLabelText(fieldset, list[idx + 1]) || getLabelText(fieldset, list[idx - 1]) || '';
    }
    popup.querySelectorAll('[data-popup-peek="0"]').forEach((el) => {
      el.textContent = a;
    });
    popup.querySelectorAll('[data-popup-peek="1"]').forEach((el) => {
      el.textContent = b;
    });
    popup.querySelectorAll('[data-popup-peek-divider]').forEach((d) => {
      d.hidden = list.length < 2 || !b || a === b;
    });
  }

  function bindFitInteractions(popup, fitRange) {
    const fit = popup.querySelector('.product-variant-popup__fit');
    const wrap = popup.querySelector('.product-variant-popup__fit-range-wrap');
    if (!fitRange || !fit) return;

    const labelTexts = () =>
      [...popup.querySelectorAll('.product-variant-popup__fit-label')].map((el) => el.textContent.trim());

    const syncAria = () => {
      const labels = labelTexts();
      const v = Number(fitRange.value);
      fitRange.setAttribute('aria-valuetext', labels[v] || labels[1] || '');
      popup.style.setProperty('--variant-fit-value', String(v));
    };

    const applyValue = (raw) => {
      const v = Math.max(0, Math.min(2, Number(raw)));
      fitRange.value = String(v);
      fitRange.dispatchEvent(new Event('input', { bubbles: true }));
      syncAria();
    };

    fit.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-fit-value]');
      if (!btn) return;
      e.preventDefault();
      applyValue(btn.dataset.fitValue);
    });

    wrap?.addEventListener('click', (e) => {
      if (e.target.closest('[data-fit-value]')) return;
      if (e.target === fitRange || e.target.closest('.product-variant-popup__fit-range')) return;
      const rect = wrap.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const ratio = rect.width > 0 ? x / rect.width : 0.5;
      const step = ratio < 1 / 3 ? 0 : ratio < 2 / 3 ? 1 : 2;
      applyValue(step);
    });

    fitRange.addEventListener('input', syncAria);
    syncAria();
  }

  function getCartUpsellVariants(popup) {
    const json = popup.querySelector('[data-cart-upsell-variants]');
    if (!json) return [];
    try {
      return JSON.parse(json.textContent);
    } catch (e) {
      return [];
    }
  }

  function syncCartUpsellVariant(popup) {
    const fieldset = popup.querySelector('[data-variant-popup-fieldset]');
    const formId = popup.dataset.formId;
    const form = formId ? document.getElementById(formId) : null;
    const variantInput = form?.querySelector('[data-cart-upsell-variant-input], input[name="id"]');
    if (!fieldset || !variantInput) return null;

    const selectedValues = [...fieldset.querySelectorAll('input[type="radio"]:checked')].map((input) => input.value);
    const variants = getCartUpsellVariants(popup);
    const variant = variants.find((entry) =>
      selectedValues.every((value, index) => entry.options[index] === value)
    );

    if (variant) {
      variantInput.value = variant.id;
    }

    return variant;
  }

  function clearCartDrawerErrors() {
    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (errors) errors.textContent = '';
  }

  function cartUpsellAddToCart(popup, buyBtn) {
    const formId = popup.dataset.formId;
    const form = formId ? document.getElementById(formId) : null;
    const variant = syncCartUpsellVariant(popup);

    if (!variant || !variant.available) {
      buyBtn.disabled = false;
      return;
    }

    const formData = new FormData();
    formData.append('id', String(variant.id));
    formData.append('quantity', '1');

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(buyBtn);
      }
    }

    const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then((r) => r.json())
      .then((data) => {
        if (data.status) {
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = data.description || window.cartStrings?.error || '';
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'cart-upsell-variant-popup',
              productVariantId: variant.id,
              errors: data.errors || data.description,
              message: data.message,
            });
          }
          return;
        }

        clearCartDrawerErrors();
        closeDialog(popup);

        if (popupRedirectsToCart(popup)) {
          window.location.href = window.routes?.cart_url || `${window.shopUrl || ''}/cart`;
          return;
        }

        if (cart && typeof cart.renderContents === 'function' && data.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        }
      })
      .catch(() => {
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings?.error || '';
      })
      .finally(() => {
        buyBtn.disabled = false;
      });
  }

  function cartUpsellDirectAdd(button) {
    const wrapper = button.closest('.cart-drawer__upsell-wrapper');
    const form = wrapper?.querySelector('[data-cart-upsell-form]');
    const variantInput = form?.querySelector('input[name="id"]');
    const variantId = variantInput?.value;

    if (!variantId) return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    const spinner = button.querySelector('.loading__spinner');
    spinner?.classList.remove('hidden');

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(button);
      }
    }

    const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then((r) => r.json())
      .then((data) => {
        if (data.status) {
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = data.description || window.cartStrings?.error || '';
          return;
        }

        clearCartDrawerErrors();

        if (cart && typeof cart.renderContents === 'function' && data.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        }
      })
      .catch(() => {
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings?.error || '';
      })
      .finally(() => {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        spinner?.classList.add('hidden');
      });
  }

  function variantPopupAddToCartAndCheckout(productInfo, sectionId, buyBtn, onDone) {
    const productForm = productInfo?.querySelector('product-form form');
    const submit = productInfo?.querySelector(`#ProductSubmitButton-${sectionId}`);
    if (!productForm || submit?.hasAttribute('disabled')) {
      onDone?.();
      return;
    }

    const idInput = productForm.querySelector('input[name="id"]');
    const variantId = idInput?.value;
    if (!variantId) {
      onDone?.();
      return;
    }

    const formData = new FormData();
    formData.append('id', variantId);
    const qtyInput = productForm.querySelector('input[name="quantity"]');
    const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    formData.append('quantity', String(quantity));

    productForm.querySelectorAll('input[name^="properties["], textarea[name^="properties["]').forEach((input) => {
      if (input.name && input.value) formData.append(input.name, input.value);
    });

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }

    const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then((r) => r.json())
      .then((data) => {
        if (data.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-variant-popup',
              productVariantId: variantId,
              errors: data.errors || data.description,
              message: data.message,
            });
          }
          return;
        }
        onDone?.();
        window.location.href = window.routes.cart_url || `${window.shopUrl}/cart`;
      })
      .catch(() => {})
      .finally(() => {
        buyBtn.disabled = false;
      });
  }

  function mountFieldsetInSheet(popup) {
    const fieldset = popup.querySelector('[data-variant-popup-fieldset]');
    const mount = popup.querySelector('[data-fieldset-mount]');
    if (fieldset && mount && fieldset.parentElement !== mount) {
      mount.appendChild(fieldset);
    }
  }

  function mountFieldsetInline(popup) {
    const fieldset = popup.querySelector('[data-variant-popup-fieldset]');
    const inline = popup.querySelector('[data-inline-mount]');
    if (fieldset && inline && fieldset.parentElement !== inline) {
      inline.appendChild(fieldset);
    }
  }

  function moveFieldset(popup) {
    const dialog = popup.querySelector('[data-variant-popup-dialog]');
    if (dialog && !dialog.hidden) {
      mountFieldsetInSheet(popup);
      return;
    }

    if (isCollectionCardPopup(popup)) {
      return;
    }

    if (window.matchMedia(MQ).matches) {
      mountFieldsetInSheet(popup);
    } else {
      mountFieldsetInline(popup);
    }
  }

  function closeDialog(popup) {
    const dialog = popup.querySelector('[data-variant-popup-dialog]');
    const openBtn = popup.querySelector('[data-variant-popup-open]');
    if (!dialog || dialog.hidden) return;
    dialog.hidden = true;
    openBtn?.setAttribute('aria-expanded', 'false');
    if (!window.matchMedia(MQ).matches && !isCollectionCardPopup(popup)) {
      mountFieldsetInline(popup);
    }
    variantPopupTryScrollUnlock(popup);
    if (!popupPreservesPageScroll(popup) && window.lenis && typeof window.lenis.start === 'function') {
      window.lenis.start();
    }
    openBtn?.focus({ preventScroll: true });
  }

  function openDialog(popup) {
    const dialog = popup.querySelector('[data-variant-popup-dialog]');
    const openBtn = popup.querySelector('[data-variant-popup-open]');
    const fieldset = popup.querySelector('[data-variant-popup-fieldset]');
    if (!dialog || !fieldset) return;

    if (isCollectionCardPopup(popup)) {
      portalCollectionPopup(popup);
    }

    mountFieldsetInSheet(popup);
    dialog.hidden = false;
    openBtn?.setAttribute('aria-expanded', 'true');
    variantPopupScrollLock(popup);
    if (!popupPreservesPageScroll(popup) && window.lenis && typeof window.lenis.stop === 'function') {
      window.lenis.stop();
    }
    updatePeekTexts(popup, fieldset);
    const first =
      fieldset.querySelector('input[type="radio"]:not(.disabled)') || fieldset.querySelector('input[type="radio"]');
    first?.focus({ preventScroll: true });
  }

  function bindPopup(popup) {
    if (isCollectionCardPopup(popup)) {
      portalCollectionPopup(popup);
    }

    moveFieldset(popup);
    const fs = popup.querySelector('[data-variant-popup-fieldset]');
    if (fs) updatePeekTexts(popup, fs);

    popup.openVariantPopup = () => openDialog(popup);

    const isCartUpsell = popup.hasAttribute('data-cart-upsell-variant-popup');

    if (popup.dataset.variantPopupBound) {
      return;
    }
    popup.dataset.variantPopupBound = 'true';

    const openBtn = popup.querySelector('[data-variant-popup-open]');
    const dialog = popup.querySelector('[data-variant-popup-dialog]');
    const fieldset = popup.querySelector('[data-variant-popup-fieldset]');
    const scrollBtn = popup.querySelector('[data-variant-popup-scroll-options]');
    const buyBtn = popup.querySelector('[data-variant-popup-buy]');
    const fitRange = popup.querySelector('.product-variant-popup__fit-range');
    const sectionId = popup.dataset.sectionId;

    if (!dialog || !fieldset) return;
    if (!isCartUpsell && !openBtn) return;

    const open = () => openDialog(popup);
    const close = () => closeDialog(popup);

    openBtn?.addEventListener('click', () => {
      if (!window.matchMedia(MQ).matches) return;
      open();
    });

    popup.querySelectorAll('[data-variant-popup-close]').forEach((el) => {
      el.addEventListener('click', close);
    });

    dialog.querySelector('.product-variant-popup__backdrop')?.addEventListener('click', close);

    scrollBtn?.addEventListener('click', () => {
      fieldset.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    fieldset.addEventListener('change', () => {
      updatePeekTexts(popup, fieldset);
      if (isCartUpsell) syncCartUpsellVariant(popup);
    });

    buyBtn?.addEventListener('click', () => {
      if (isCartUpsell) {
        if (buyBtn.disabled) return;
        buyBtn.disabled = true;
        cartUpsellAddToCart(popup, buyBtn);
        return;
      }

      const productInfo = popup.closest('product-info');
      if (!productInfo || buyBtn.disabled) return;
      buyBtn.disabled = true;
      variantPopupAddToCartAndCheckout(productInfo, sectionId, buyBtn, () => close());
    });

    if (fitRange) {
      bindFitInteractions(popup, fitRange);
    }

    const mq = window.matchMedia(MQ);
    mq.addEventListener('change', () => {
      if (dialog.hidden) {
        moveFieldset(popup);
      }
    });

    moveFieldset(popup);
    updatePeekTexts(popup, fieldset);
    if (isCartUpsell) syncCartUpsellVariant(popup);
  }

  function initCartUpsellPopups() {
    document.querySelectorAll('[data-cart-upsell-variant-popup]').forEach(bindPopup);
  }

  function setupGlobalsOnce() {
    if (window.__productVariantPopupListeners) return;
    window.__productVariantPopupListeners = true;

    document.addEventListener('click', (event) => {
      const directBtn = event.target.closest('[data-cart-upsell-direct-add]');
      if (directBtn) {
        cartUpsellDirectAdd(directBtn);
        return;
      }

      const button = event.target.closest('[data-cart-upsell-open-variant]');
      if (button) {
        const wrapper = button.closest('.cart-drawer__upsell-wrapper');
        const popup = wrapper?.querySelector('[data-cart-upsell-variant-popup]');
        if (!popup) return;

        bindPopup(popup);
        openDialog(popup);
        return;
      }

      const collectionButton = event.target.closest('[data-collection-open-variant]');
      if (collectionButton) {
        event.preventDefault();
        const sectionId = collectionButton.dataset.variantPopupSectionId;
        const popup =
          getCollectionCardPopup(sectionId) ||
          collectionButton.closest('[data-collection-card-variant]')?.querySelector('[data-cart-upsell-variant-popup]');
        if (!popup) return;

        bindPopup(popup);
        openDialog(popup);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const openDialogEl = document.querySelector('[data-variant-popup-dialog]:not([hidden])');
      if (!openDialogEl) return;
      const popup =
        openDialogEl.closest('[data-product-variant-popup]') ||
        openDialogEl.closest('[data-cart-upsell-variant-popup]');
      if (popup) closeDialog(popup);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        requestAnimationFrame(() => {
          document.querySelectorAll('[data-product-variant-popup]').forEach((popup) => {
            bindPopup(popup);
            const fieldset = popup.querySelector('[data-variant-popup-fieldset]');
            if (fieldset) updatePeekTexts(popup, fieldset);
          });
        });
      });
    }
  }

  function boot() {
    setupGlobalsOnce();
    document.querySelectorAll('[data-product-variant-popup]').forEach(bindPopup);
  }

  window.initProductVariantPopups = boot;
  window.initCartUpsellPopups = initCartUpsellPopups;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', () => {
    boot();
  });
})();
